<template>
  <section>
    <loader-wrapper v-if="Object.keys(calculator).length" :loading="loading">
      <el-card
        v-for="(block, i) in blocks"
        :key="i"
        :class="{ 'calc-mob-list': isMobile }"
      >
        <el-row
          :type="isMobile ? '' : 'flex'"
          :gutter="isMobile ? 0 : 100"
          justify="space-between"
        >
          <results-items
            v-for="(b, n) in block"
            :key="n"
            :items="calculator[b]"
            :count="calculator[`${b}_count`]"
            :config="results[b]"
            @show="setMap"
          />
        </el-row>
      </el-card>
    </loader-wrapper>
    <el-dialog
      :visible.sync="dialog_calc_map"
      title="Координаты погрузок"
      width="100%"
      top="5px"
      @close="setMap()"
    >
      <calc-items-y-map :items="items" :config="config" />
    </el-dialog>
  </section>
</template>

<script>
import { blocks, results } from '../constants'
import { mapGetters } from 'vuex'
import CalcItemsYMap from '@/components/Maps/CalcItemsYMap'
import ResultsItems from './ResultsItems'

export default {
  name: 'ResultsLists',
  components: { ResultsItems, CalcItemsYMap },
  data() {
    return {
      blocks,
      results,
      items: [],
      config: {},
      dialog_calc_map: false,
    }
  },
  computed: {
    ...mapGetters('bids', ['calculator', 'getLoading']),
    loading() {
      return this.getLoading('Calc')
    },
  },
  methods: {
    setMap(items = [], config) {
      this.items = items
      this.config = config
      this.dialog_calc_map = Boolean(items.length)
    },
  },
}
</script>

<style lang="sass">
.calc-mob-list
  .el-card__body
    padding: 20px 0
</style>
